import React from 'react';
import { usePrivacySettingsHook, useSmartWelcomeHook } from './hooks';
import { Container as StyledContainer } from '../styles/welcomeStyles';
import PrivacySettings from './PrivacySettings';
import LoaderBlock from './LoaderBlock';
import PrivacySettingsRebrand from './PrivacySettingsRebrand';
import { Loader } from '@clientos/ui-toolkit';
import { APP_NAME } from '../constants/queryParams';
import FontLoader from '../FontLoader';
import ThemeProvider from '../components/ThemeProvider';
import PSAPrivacySettings from './PSAPrivacySettings';

const UpdateContainer = ({ consentsUpdate, reTarget, currentStack }) => {
  const printerWelcomeProps = useSmartWelcomeHook({
      consentsUpdate,
      currentStack
    });

  const { noContent, query } = printerWelcomeProps;
  
  const smartWelcomeProps = { ...printerWelcomeProps, reTarget };

  const privacySettingsProps = usePrivacySettingsHook(consentsUpdate, currentStack);

 const isHPX = query?.brand === 'hpx';
    const queryAppName = (query.appName || '').toLowerCase();

  const hasPSAGenConsent = queryAppName === (APP_NAME.PSA_GEN_CONSENT || '').toLowerCase();

  if (noContent) {
    return (
      <StyledContainer data-testid="no-content">
        {isHPX ? <Loader type="circular" /> : <LoaderBlock />}
      </StyledContainer>
    );
  }

  if (hasPSAGenConsent) {
    return (
      <ThemeProvider>
        <FontLoader>
          <PSAPrivacySettings {...smartWelcomeProps} />
        </FontLoader>
      </ThemeProvider>
    );
  }

  return isHPX ? (
    <PrivacySettingsRebrand {...privacySettingsProps} />
  ) : (
    <PrivacySettings {...privacySettingsProps} />
  );
};

export default UpdateContainer;
